import {API} from '../axios';

const END_POINT_STATUS = '/notices';

const getMessagesData = (params) => API.get(END_POINT_STATUS,params);
export {
    getMessagesData,
}